import type { FC } from 'react';

import { Anchor } from 'src/components/common/atoms';

type Props = Pick<Queries.PageInfo, 'hasPreviousPage' | 'currentPage'> & {
  className?: string;
  archivePath: string;
};

const getPreviousLink = ({
  currentPage,
  archivePath,
}: Pick<Props, 'currentPage' | 'archivePath'>) => {
  let previousLink: string | null = null;
  if (2 === currentPage) {
    previousLink = archivePath;
  } else if (2 < currentPage) {
    previousLink = `${archivePath}/page/${currentPage - 1}/`;
  }
  return previousLink;
};

export const Previous: FC<Props> = ({
  className,
  hasPreviousPage,
  currentPage,
  archivePath,
}) => {
  if (!hasPreviousPage) {
    return <span />;
  }
  const previousLink = getPreviousLink({ currentPage, archivePath });
  if (!previousLink) {
    return <span />;
  }

  return (
    <Anchor className={className ?? ''} to={previousLink}>
      <span aria-label="Previous page">Prev</span>
    </Anchor>
  );
};

export default Previous;
